import React from 'react';

import Strong from '@tds/core-strong';
import { Information } from '@tds/core-decorative-icon';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { NoInfoContainer } from './css';

const NoInformationFound = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    general: { noInformationFound }
  } = localizedStrings;
  return (
    <NoInfoContainer>
      <Information />
      <div style={{ marginTop: '1rem' }}>
        <Strong>{noInformationFound}</Strong>
      </div>
    </NoInfoContainer>
  );
};

export default NoInformationFound;
